export default __webpack_public_path__ + "static/media/reddit_kod.f98a8e07.webp";